import $ from 'jquery';
import 'jquery-validation';
import 'jquery.validate.unobtrusive';
import AppEvents from 'Shared/app-events';

export default class Validation
{
    static getLabel(element) {
        var label = $(element).next("label");
        if (label.length) {
            return label;
        } else {
            label = $(`label[for='${element.id}']`);
            if (label.length) {
                return label;
            }
        }

        return null;
    }

    static defaults = async (culture, defaults = {
        highlight: (element, errorClass) => {
            let control = element?.closest('.k-dropdownlist') || element;

            $(control).addClass("is-invalid");
            const $label = Validation.getLabel(control);
            if ($label && $label.length && control.type !== "checkbox") {
                $label.hide();
            }
        },
        unhighlight: element => {
            let control = element.closest('.k-dropdownlist') || element;

            $(control).removeClass("is-invalid");
            var $label = Validation.getLabel(control);
            if ($label && $label.length && control.type !== "checkbox") {
                $label.show();
            }
        },
        ignore: "[novalidate]",
        errorClass: 'is-invalid',
        errorElement: 'label',
        errorPlacement: (error, element) => {
            let control = element[0].closest('.k-dropdownlist') || element[0];

            if (control.type === "checkbox") {
                error.addClass("d-block");
            }

            var $label = Validation.getLabel(control);
            if ($label && $label.length) {
                error.insertAfter($label);
            } else {
                error.insertAfter(element);
            }
        }
    }) => {
        var lang = 'de';

        if (culture.toLowerCase() === 'de-de') {
            lang = 'de';
        } else if (culture.toLowerCase() === 'fr-fr') {
            lang = 'fr';
        } else if (culture.toLowerCase() === 'it-it') {
            lang = 'it';
        } else if (culture.toLowerCase() === 'da-dk') {
            lang = 'da';
        }

        await import(/* webpackChunkName: "val-lang-[request]" */`../../node_modules/jquery-validation/dist/localization/messages_${lang}.min.js`);

        $.validator.setDefaults(defaults);
        //$.validator.unobtrusive.options = defaults;

        var originalMethods = {
            min: $.validator.methods.min,
            max: $.validator.methods.max,
            range: $.validator.methods.range
        };

        // Tell the validator that we want numbers parsed using Globalize

        $.validator.methods.number = function (value, element) {
            var val = window.Globalize.parseNumber(value);
            return this.optional(element) || ($.isNumeric(val));
        };

        // Tell the validator that we want dates parsed using Globalize

        $.validator.methods.date = function (value, element) {
            var parser = window.Globalize.dateParser();

            var val = parser(value);
            return this.optional(element) || (val instanceof Date);
        };

        // Tell the validator that we want numbers parsed using Globalize, 
        // then call into original implementation with parsed value

        $.validator.methods.min = function (value, element, param) {
            let val = value;

            switch (element.type) {
                case 'number':
                    val = window.Globalize.parseNumber(value);
                    break;
                default:
                    break;
            }
            
            return originalMethods.min.call(this, val, element, param);
        };

        $.validator.methods.max = function (value, element, param) {
            let val = value;

            switch (element.type) {
                case 'number':
                    val = window.Globalize.parseNumber(value);
                    break;
                default:
                    break;
            }

            return originalMethods.max.call(this, val, element, param);
        };

        $.validator.methods.range = function (value, element, param) {
            var val = window.Globalize.parseNumber(value);
            return originalMethods.range.call(this, val, element, param);
        };


        AppEvents.onPreInit(() => {
            $("form").each((idx, form) => {
                var $errors = $(form).find(".field-validation-error");
                if ($errors.length) {
                    var errorList = {};

                    $errors.each((i, error) => {
                        errorList[error.dataset.valmsgFor] = error.innerText;
                    })

                    $(form).validate().showErrors(errorList);
                }

                $(form).on("blur", "input", function () {
                    const validator = $(form).data("validator");
                    if (!validator) return;
                    const $input = $(this);

                    $input
                        .removeClass("input-validation-error is-invalid")
                        .addClass("form-control")
                        .attr("aria-invalid", "false");

                    $(form).find("[data-valmsg-for='" + this.id + "']")
                        .removeClass("field-validation-error")
                        .addClass("field-validation-valid")
                        .empty();

                    $(form).find("#" + this.id + "-error")
                        .remove();
                    $(form).find("label[for='" + this.id + "']")
                        .css("display", "");
                });
            });

            $("form [data-valmsg-for]").each((idx, val) => {
                let html = val.outerHTML;
                html = html.replace("<span", "<label");
                html = html.replace("</span", "</label");

                $(val).replaceWith(html);
            });
        });
    }
}